/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateWarehouseDto
 */
export interface UpdateWarehouseDto {
    /**
     * Warehouse name
     * @type {string}
     * @memberof UpdateWarehouseDto
     */
    name?: string;
    /**
     * Whether warehouse is active
     * @type {boolean}
     * @memberof UpdateWarehouseDto
     */
    isActive?: boolean;
    /**
     * Contact info ID
     * @type {number}
     * @memberof UpdateWarehouseDto
     */
    contactInfoId?: number;
    /**
     * Contact phone number
     * @type {string}
     * @memberof UpdateWarehouseDto
     */
    phoneNumber?: string;
    /**
     * Street address
     * @type {string}
     * @memberof UpdateWarehouseDto
     */
    street?: string;
    /**
     * Building number
     * @type {string}
     * @memberof UpdateWarehouseDto
     */
    buildingNumber?: string;
    /**
     * Formatted address for display
     * @type {string}
     * @memberof UpdateWarehouseDto
     */
    formattedAddress?: string;
    /**
     * Latitude
     * @type {number}
     * @memberof UpdateWarehouseDto
     */
    latitude?: number;
    /**
     * Longitude
     * @type {number}
     * @memberof UpdateWarehouseDto
     */
    longitude?: number;
}

/**
 * Check if a given object implements the UpdateWarehouseDto interface.
 */
export function instanceOfUpdateWarehouseDto(value: object): value is UpdateWarehouseDto {
    return true;
}

export function UpdateWarehouseDtoFromJSON(json: any): UpdateWarehouseDto {
    return UpdateWarehouseDtoFromJSONTyped(json, false);
}

export function UpdateWarehouseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateWarehouseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'contactInfoId': json['contactInfoId'] == null ? undefined : json['contactInfoId'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'street': json['street'] == null ? undefined : json['street'],
        'buildingNumber': json['buildingNumber'] == null ? undefined : json['buildingNumber'],
        'formattedAddress': json['formattedAddress'] == null ? undefined : json['formattedAddress'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
    };
}

export function UpdateWarehouseDtoToJSON(value?: UpdateWarehouseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'isActive': value['isActive'],
        'contactInfoId': value['contactInfoId'],
        'phoneNumber': value['phoneNumber'],
        'street': value['street'],
        'buildingNumber': value['buildingNumber'],
        'formattedAddress': value['formattedAddress'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
    };
}

